import { useEffect, useState } from "react";
import { baseUrl } from "../../Environments/environment";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import { Tick } from "../../icons/Tick";
import { useSelector, useDispatch } from "react-redux";
import {
	addSelectedAddOn,
	filterAddOnRequests,
	filterCheckInOutRequsts,
	setAllAddOns,
	setEarlyCheckInTime,
	setGuestAddons,
	setGuestCheckInOutRequests,
	setLateCheckOutTime,
} from "../../redux/addOn/addOnSlice";
import DateandTimePicker from "../CheckIn/Addon/DateandTimePicker";
import LateCheckoutTimePicker from "../CheckIn/Addon/LateCheckoutTimePicker";
import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const getFormattedDate = () => {
	const today = new Date();
	const month = String(today.getMonth() + 1).padStart(2, "0");
	const day = String(today.getDate()).padStart(2, "0");
	const year = today.getFullYear();
	return `${month}/${day}/${year}`;
};

const convert24to12 = (time24) => {
	try {
		return moment(time24, "HH:mm").format("hh:mm A");
	} catch (error) {
		console.error("Error converting 24h to 12h format:", error);
		return "";
	}
};

const convert12to24 = (time12) => {
	try {
		return moment(time12, "hh:mm A").format("HH:mm");
	} catch (error) {
		console.error("Error converting 12h to 24h format:", error);
		return "";
	}
};

// Skeleton Loading Component
const AddOnsSkeleton = () => (
	<div className="relative h-screen overflow-auto">
		<div className="flex flex-col justify-start items-center bg-gray-900 min-h-full w-full">
			{/* Header Skeleton */}
			<div className="w-full flex flex-col items-center mt-10 mb-8 px-5">
				<div className="h-12 bg-gray-700 rounded w-48 animate-pulse mb-4"></div>
				<div className="w-24 h-0.5 bg-gray-700 animate-pulse"></div>
			</div>

			{/* Cards Skeleton */}
			<div className="bg-white p-4 rounded-lg shadow-md w-full max-w-sm mx-6 my-5">
				<div className="mt-4 mb-4">
					<div className="space-y-4">
						{/* Skeleton Card 1 */}
						<div className="rounded-md animate-pulse">
							<div className="bg-gray-200 mb-2 rounded-md h-36"></div>
							<div className="flex justify-between mb-2">
								<div className="h-6 bg-gray-200 rounded w-32"></div>
								<div className="h-6 bg-gray-200 rounded w-16"></div>
							</div>
							<div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
							<div className="h-10 bg-gray-200 rounded"></div>
						</div>

						{/* Skeleton Card 2 */}
						<div className="rounded-md animate-pulse">
							<div className="bg-gray-200 mb-2 rounded-md h-36"></div>
							<div className="flex justify-between mb-2">
								<div className="h-6 bg-gray-200 rounded w-40"></div>
								<div className="h-6 bg-gray-200 rounded w-16"></div>
							</div>
							<div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
							<div className="h-10 bg-gray-200 rounded"></div>
						</div>

						{/* Skeleton Card 3 */}
						<div className="rounded-md animate-pulse">
							<div className="bg-gray-200 mb-2 rounded-md h-36"></div>
							<div className="flex justify-between mb-2">
								<div className="h-6 bg-gray-200 rounded w-36"></div>
								<div className="h-6 bg-gray-200 rounded w-16"></div>
							</div>
							<div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
							<div className="h-10 bg-gray-200 rounded"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
);

const AddOns = ({ guestSessionId: propGuestSessionId, onBack }) => {
	// Use prop if provided, otherwise fall back to useParams for backward compatibility
	const params = useParams();
	const guestSessionId = propGuestSessionId || params.id;
	const [guest, setGuest] = useState("");
	const [addOns, setAddOns] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [requestSentStatus, setRequestSentStatus] = useState({});
	const [selectedAddOn, setSelectedAddOn] = useState(null);
	const [propertyCheckInTime, setPropertyCheckInTime] = useState("");
	const [propertyCheckOutTime, setPropertyCheckOutTime] = useState("");
	const [propertyEarlyCheckInTime, setPropertyEarlyCheckInTime] = useState("");
	const [propertyLateCheckOutTime, setPropertyLateCheckOutTime] = useState("");
	const [propertyTimeZone, setPropertyTimeZone] = useState(null);
	const [selectedTime, setSelectedTime] = useState(propertyCheckInTime);
	const [selectedDate, setSelectedDate] = useState(getFormattedDate());
	const [isLoading, setIsLoading] = useState(false);
	const [requestStatus, setRequestStatus] = useState(null);
	const [preArrivalFlow, setPreArrivalFlow] = useState(null);
	const [arrivalTime, setArrivalTime] = useState("");
	const [loadingAddOnId, setLoadingAddOnId] = useState(null);
	const [showEarlyCheckInButton, setShowEarlyCheckInButton] = useState(false);
	const [lateCheckoutRequestStatus, setlateCheckoutRequestStatus] =
		useState(null);
	const [lateCheckoOutSelectedTime, setLateCheckoOutSelectedTime] =
		useState("");
	const [showLateCheckOutButton, setShowLateCheckOutButton] = useState(false);
	const [isLateCheckOutModalOpen, setIsLateCheckOutModalOpen] = useState(false);
	const [lateCheckOutFlag, setLateCheckOutFlag] = useState(false);
	const [isLateCheckOutLoading, setIsLateCheckOutLoading] = useState(false);

	const storeAddOns = useSelector((state) => state.addOn);
	const dispatch = useDispatch();

	const getWorkFlow = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/workflow`,
			);

			setPreArrivalFlow(response.data.result.preArrivalFlow);
			setPropertyCheckInTime(
				response.data.result.settingFlow.standardCheckinTime,
			);
			setArrivalTime(response.data.result.settingFlow.standardCheckinTime);
			setPropertyTimeZone(response.data.result.settingFlow.timezone);
			setPropertyCheckOutTime(
				response.data.result.settingFlow.standardCheckoutTime,
			);
			if (
				response.data.result &&
				response.data.result.addOnsFlow &&
				response.data.result.addOnsFlow.checkInOutAddOns.length > 0 &&
				response.data.result.addOnsFlow.checkInOutAddOns[0].enabled
			)
				setPropertyEarlyCheckInTime(
					response.data.result.addOnsFlow.checkInOutAddOns[0],
				);

			if (
				response.data.result &&
				response.data.result.addOnsFlow &&
				response.data.result.addOnsFlow.checkInOutAddOns.length > 0 &&
				response.data.result.addOnsFlow.checkInOutAddOns[1].enabled
			)
				setPropertyLateCheckOutTime(
					response.data.result.addOnsFlow.checkInOutAddOns[1],
				);
			const tempArr = [
				...response.data.result.addOnsFlow.checkInOutAddOns,
				...response.data.result.addOnsFlow.customAddOns,
			];

			setAddOns(tempArr);
			dispatch(setAllAddOns(tempArr));
		} catch (error) {
			console.error("Error submitting data:", error);
		}
	};

	const getGuest = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/guest`,
			);
			setGuest(response.data.result);
		} catch (error) {
			console.error("Error submitting data:", error);
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			await getGuest();
		};

		fetchData();
	}, []);

	const getGuestCheckInOutRequests = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
			);
			dispatch(setGuestCheckInOutRequests(response.data.result));
			dispatch(filterCheckInOutRequsts(response.data.result));
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};

	const getGuestAddons = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/addOns`,
			);
			dispatch(filterAddOnRequests(response.data.result));
			dispatch(setGuestAddons(response.data.result));
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};

	useEffect(() => {
		getGuestCheckInOutRequests();
		getGuestAddons();
	}, [requestStatus, lateCheckoutRequestStatus]);

	useEffect(() => {
		getWorkFlow();
	}, [guest]);

	useEffect(() => {
		if (selectedTime && selectedTime !== propertyCheckInTime) {
			setShowEarlyCheckInButton(true);
		} else {
			setShowEarlyCheckInButton(false);
		}
	}, [selectedTime, propertyCheckInTime]);

	useEffect(() => {
		if (
			lateCheckoOutSelectedTime &&
			lateCheckoOutSelectedTime !== propertyCheckOutTime
		) {
			setShowLateCheckOutButton(true);
		} else {
			setShowLateCheckOutButton(false);
		}
	}, [lateCheckoOutSelectedTime, propertyCheckOutTime]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const handleSendRequest = (addOn) => {
		setSelectedAddOn(addOn);
		if (addOn.addOnType != "CustomAddon") {
			setIsModalOpen(true);
		} else {
			handleConfirmRequest(addOn);
		}
	};

	function formatDateTime(date, time) {
		const [day, month, year] = date.split("-");
		const formattedDate = `${year}-${month}-${day}`;
		const dateTimeString = `${formattedDate}T${time}Z`;
		return dateTimeString;
	}

	const handleEarlyCheckInAddon = async (time) => {
		const formattedTime = convert12to24(time);
		const earlyCheckInAddon = addOns.find((item) =>
			item.name.toLowerCase().includes("early check in"),
		);
		console.log("earlyCheckInAddon", earlyCheckInAddon);
		const data = {
			earlyCheckInDateTime: formatDateTime(
				moment(guest.checkIn).format("DD-MM-YYYY"),
				formattedTime,
			),
			requestType: "earlyCheckIn",
			checkInOutRequestId: earlyCheckInAddon._id,
		};
		try {
			setIsLoading(true);
			setLoadingAddOnId(earlyCheckInAddon._id);
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
				data,
			);

			if (response.status === 200) {
				setRequestStatus("success");
				dispatch(addSelectedAddOn(earlyCheckInAddon._id));
			} else {
				setRequestStatus("failure");
			}
		} catch (error) {
			setRequestStatus("failure");
			console.log(error);
		} finally {
			setLoadingAddOnId(null);
			setIsLoading(false);
		}
	};

	const handleLateCheckOutAddon = async (time) => {
		const formattedTime = convert12to24(time);
		const lateCheckOutAddon = addOns.find((item) =>
			item.name.toLowerCase().includes("late check out"),
		);
		console.log("lateCheckOutAddon", lateCheckOutAddon);
		const data = {
			lateCheckOutDateTime: formatDateTime(
				moment(guest.checkOut).format("DD-MM-YYYY"),
				formattedTime,
			),
			requestType: "lateCheckOut",
			checkInOutRequestId: lateCheckOutAddon._id,
		};
		try {
			setIsLateCheckOutLoading(true);
			setLoadingAddOnId(lateCheckOutAddon._id);
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
				data,
			);

			if (response.status === 200) {
				setlateCheckoutRequestStatus("success");
				dispatch(addSelectedAddOn(lateCheckOutAddon._id));
			} else {
				setlateCheckoutRequestStatus("failure");
			}
		} catch (error) {
			setlateCheckoutRequestStatus("failure");
			toast.error(error.response.data.error.message);
			console.log(error);
		} finally {
			setLoadingAddOnId(null);
			setIsLateCheckOutLoading(false);
		}
	};

	const handleConfirmRequest = async (addOn) => {
		await sendRequestToBackend(addOn);
		setIsModalOpen(false);
	};

	const sendRequestToBackend = async (selectedAddOn) => {
		console.log("sendRequestToBack", selectedAddOn);
		const data = {
			addOnsId: selectedAddOn._id,
		};
		try {
			setIsLoading(true);
			setLoadingAddOnId(selectedAddOn._id);
			setRequestStatus("idle");
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/addOnsRequest`,
				data,
			);
			if (response.status === 201) {
				setRequestStatus("success");
				dispatch(addSelectedAddOn(selectedAddOn));
			} else {
				setRequestStatus("failure");
			}
		} catch (error) {
			setRequestStatus("failure");
			console.log(error);
		} finally {
			setLoadingAddOnId(null);
			setIsLoading(false);
		}
	};

	return (
		<>
			{!addOns && <AddOnsSkeleton />}

			{/* Main content */}
			{addOns && (
				<div className="relative h-screen overflow-auto">
					<div className="flex flex-col justify-start items-center bg-gray-900 min-h-full w-full">
						{/* Header - Simple and Classy */}
						<div className="w-full flex flex-col items-center mt-6 mb-6 px-5">
							<h1 className="text-3xl font-light text-white font-poppins text-center tracking-tight mb-3">
								Services
							</h1>
							<div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-indigo-400 to-transparent"></div>
						</div>

						<div
							className={`bg-white p-5 rounded-xl shadow-lg w-full max-w-sm mx-6 my-5 border border-gray-100`}
						>
							<div className="mt-2 mb-2">
								<div className="space-y-5">
									{storeAddOns.allAddOns
										.filter(
											(addOn) =>
												!(
													addOn.name?.toLowerCase().includes("early") &&
													guest.status.currentStatus === "In House"
												),
										)
										.map((addOn) => (
											<div 
												key={addOn._id} 
												className="rounded-xl overflow-hidden border border-gray-200 hover:border-indigo-300 hover:shadow-md transition-all duration-300 bg-white"
											>
												<div className="bg-gradient-to-br from-gray-50 to-gray-100 mb-3 rounded-t-xl overflow-hidden">
													<img
														src={(() => {
															if (addOn.name?.toLowerCase().includes("early")) {
																return "https://onelyk-images-bucket.s3.us-east-1.amazonaws.com/addOns/early+check+in.png";
															} else if (
																addOn.name?.toLowerCase().includes("late")
															) {
																return "https://onelyk-images-bucket.s3.us-east-1.amazonaws.com/addOns/late+check+out.png";
															} else if (addOn.image) {
																return addOn.image;
															} else {
																return "https://st3.depositphotos.com/1022597/35608/i/450/depositphotos_356083076-stock-photo-grey-stone-texture-useful-background.jpg";
															}
														})()}
														className="w-full h-44 object-cover hover:scale-105 transition-transform duration-300"
													/>
												</div>
												<div className="px-4 pb-3">
													<div className="flex justify-between items-start mb-2">
														<div className="text-lg font-semibold text-gray-900 flex-1">
															{addOn.name}
														</div>
														{(!addOn.paid ||
														addOn.price === undefined ||
														addOn.price === 0) ? null : (
															<div className="text-lg font-bold text-indigo-600 ml-3">
																${addOn.price}
															</div>
														)}
													</div>
													<div className="text-gray-600 mb-4 text-sm leading-relaxed line-clamp-2">
														{addOn.description}
													</div>
													{addOn.addOnType !== "CustomAddon" ? (
														<>
															{addOn.name.toLowerCase().includes("early") ? (
															storeAddOns?.guestCheckInOutRequests?.some(
																(selectedAddOn) =>
																	selectedAddOn.requestType ===
																		"earlyCheckIn" &&
																	selectedAddOn.requestStatus !== "Declined",
															) ? (
																<button
																	className="w-full py-2.5 bg-green-50 text-green-700 rounded-lg flex items-center justify-center font-medium border-2 border-green-200 shadow-sm"
																	disabled
																>
																	<span className="mr-2">
																		<Tick />
																	</span>
																	{storeAddOns.guestCheckInOutRequests.find(
																		(selectedAddOn) =>
																			selectedAddOn.requestType ===
																			"earlyCheckIn",
																	)?.requestStatus === "Accepted"
																		? "Request Accepted"
																		: "Request Sent"}
																</button>
															) : loadingAddOnId === addOn._id ? (
																<button
																	className="w-full py-2.5 border-2 border-indigo-600 text-indigo-600 rounded-lg hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center font-medium transition-all duration-200"
																	disabled
																>
																	<svg
																		className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
																		xmlns="http://www.w3.org/2000/svg"
																		fill="none"
																		viewBox="0 0 24 24"
																	>
																		<circle
																			className="opacity-25"
																			cx="12"
																			cy="12"
																			r="10"
																			stroke="currentColor"
																			strokeWidth="4"
																		/>
																		<path
																			className="opacity-75"
																			fill="currentColor"
																			d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																		/>
																	</svg>
																	Processing...
																</button>
															) : (
																<button
																	onClick={() => setIsModalOpen(true)}
																	className="w-full py-2.5 border-2 border-indigo-600 text-indigo-600 rounded-lg hover:bg-indigo-50 hover:border-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center font-medium transition-all duration-200 shadow-sm hover:shadow"
																>
																	Send Request
																</button>
															)
														) : addOn.name.toLowerCase().includes("late") ? (
															storeAddOns?.guestCheckInOutRequests?.some(
																(selectedAddOn) =>
																	selectedAddOn.requestType ===
																		"lateCheckOut" &&
																	selectedAddOn.requestStatus !== "Declined",
															) ? (
																<button
																	className="w-full py-2.5 bg-green-50 text-green-700 rounded-lg flex items-center justify-center font-medium border-2 border-green-200 shadow-sm"
																	disabled
																>
																	<span className="mr-2">
																		<Tick />
																	</span>
																	{storeAddOns.guestCheckInOutRequests.find(
																		(selectedAddOn) =>
																			selectedAddOn.requestType ===
																			"lateCheckOut",
																	)?.requestStatus === "Accepted"
																		? "Request Accepted"
																		: "Request Sent"}
																</button>
															) : loadingAddOnId === addOn._id ? (
																<button
																	className="w-full py-2.5 border-2 border-indigo-600 text-indigo-600 rounded-lg hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center font-medium transition-all duration-200"
																	disabled
																>
																	<svg
																		className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
																		xmlns="http://www.w3.org/2000/svg"
																		fill="none"
																		viewBox="0 0 24 24"
																	>
																		<circle
																			className="opacity-25"
																			cx="12"
																			cy="12"
																			r="10"
																			stroke="currentColor"
																			strokeWidth="4"
																		/>
																		<path
																			className="opacity-75"
																			fill="currentColor"
																			d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																		/>
																	</svg>
																	Processing...
																</button>
															) : (
																<button
																	onClick={() =>
																		setIsLateCheckOutModalOpen(true)
																	}
																	className="w-full py-2.5 border-2 border-indigo-600 text-indigo-600 rounded-lg hover:bg-indigo-50 hover:border-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center font-medium transition-all duration-200 shadow-sm hover:shadow"
																>
																	Send Request
																</button>
															)
														) : null}
													</>
												) : storeAddOns.guestAddons.some(
																(selectedAddOn) =>
																	selectedAddOn.addOnsId === addOn._id &&
																	selectedAddOn.requestStatus !== "Declined",
															) ? (
															<button
																className="w-full py-2.5 bg-green-50 text-green-700 rounded-lg flex items-center justify-center font-medium border-2 border-green-200 shadow-sm"
																disabled
															>
																<span className="mr-2">
																	<Tick />
																</span>
																{storeAddOns.guestAddons.find(
																	(selectedAddOn) =>
																		selectedAddOn.addOnsId === addOn._id,
																)?.requestStatus === "Accepted"
																	? "Request Accepted"
																	: "Request Sent"}
															</button>
														) : (
															<button
																className="w-full py-2.5 border-2 border-indigo-600 text-indigo-600 rounded-lg hover:bg-indigo-50 hover:border-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center font-medium transition-all duration-200 shadow-sm hover:shadow"
																onClick={() => handleSendRequest(addOn)}
																disabled={loadingAddOnId === addOn._id}
															>
																{loadingAddOnId === addOn._id ? (
																	<>
																		<svg
																			className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
																			xmlns="http://www.w3.org/2000/svg"
																			fill="none"
																			viewBox="0 0 24 24"
																		>
																			<circle
																				className="opacity-25"
																				cx="12"
																				cy="12"
																				r="10"
																				stroke="currentColor"
																				strokeWidth="4"
																			/>
																			<path
																				className="opacity-75"
																				fill="currentColor"
																				d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																			/>
																		</svg>
																		Processing...
																	</>
																) : (
																	"Send Request"
																)}
															</button>
													)}
												</div>
											</div>
										))}
								</div>
							</div>
						</div>
					</div>

					{/* Modal */}
					{isModalOpen && (
						<div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
							{guest && (
								<DateandTimePicker
									isModalOpen={isModalOpen}
									setIsModalOpen={setIsModalOpen}
									setRequestSent={(time) => {
										setSelectedTime(time);
										handleEarlyCheckInAddon(time);
									}}
									addon={storeAddOns.allAddOns.find((addon) => {
										if (
											addon.addOnType !== "CustomAddon" &&
											addon.name
												.toLowerCase()
												.replace(/\s+/g, "")
												.includes("early")
										)
											return addon;
									})}
									date={guest.checkIn}
									propertyEarlyCheckInTime={propertyEarlyCheckInTime}
									propertyTime={propertyCheckInTime}
									propertyTimeZone={propertyTimeZone}
								/>
							)}
						</div>
					)}

					{isLateCheckOutModalOpen && (
						<div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
							{guest && (
								<LateCheckoutTimePicker
									isModalOpen={isLateCheckOutModalOpen}
									setIsModalOpen={setIsLateCheckOutModalOpen}
									setRequestSent={(date, time) => {
										setLateCheckoOutSelectedTime(time);
										handleLateCheckOutAddon(time);
									}}
									addon={storeAddOns.allAddOns.find((addon) => {
										if (
											addon.addOnType !== "CustomAddon" &&
											addon.name
												.toLowerCase()
												.replace(/\s+/g, "")
												.includes("late")
										)
											return addon;
									})}
									propertyLateCheckOutTime={propertyLateCheckOutTime}
									propertyTime={propertyCheckOutTime}
									checkOutDate={guest.checkOut}
									propertyTimeZone={propertyTimeZone}
									lateCheckOutFlag={true}
								/>
							)}
						</div>
					)}
					<ToastContainer
						position="top-right"
						autoClose={5000}
						hideProgressBar
						newestOnTop={false}
						closeOnClick
						rtl={false}
						pauseOnFocusLoss
						draggable
						pauseOnHover
						theme="light"
						transition={Bounce}
					/>
				</div>
			)}
		</>
	);
};

export default AddOns;
